/** "my" when the data is the reader's own, "Liam's" when they are reading someone else's. */
export const subjectPossessive = (subjectName?: string) =>
  subjectName?.trim() ? `${subjectName.trim().split(' ')[0]}'s` : 'my';
